<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
			persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card style="margin: 0px;">
        <v-toolbar class="dialog-toolbar fixNotchPaddingTop">
          <v-btn icon dark @click="close()">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title color="primary">
						Solicitar cambio
					</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <div class="dialog-paged-bk-color fixNotchMarginTop" style="padding-bottom: 10px;">
        
        <v-card-text style="padding: 15px; background-color: #FFFFFF; border-radius: 4px 4px 0 0; border: thin solid rgba(0, 0, 0, 0.12); border-bottom: 0;" class="fixNotchPaddingTop pb-0">					
            <v-form ref="form" autocomplete="off">
				<v-row>
					<v-col cols="12">
						<v-text-field
							class="pt-0"
							label="Nombre clínica"
							v-model="clinica"
							:rules="[validationRules.required]"/>
					</v-col>
          <v-col cols="12" v-if="id < 7">
						<v-text-field
							class="pt-0"
							label="Dirección"
							v-model="dirclinica"/>
					</v-col>
          <v-col cols="4" v-if="id < 7">
						<v-text-field
							class="pt-0"
							label="Tipo vía"
							v-model="tipoviacli"/>
					</v-col>
					<v-col cols="4" v-if="id < 7">
						<v-text-field
							class="pt-0"
							label="Número"
							v-model="numeroclinica"/>
					</v-col>
					<v-col cols="4" v-if="id < 7">
						<v-text-field
							class="pt-0"
							label="Piso"
							v-model="pisoclinica"/>
					</v-col>
          <v-col cols="12" v-if="id < 7">
						<v-text-field
							class="pt-0"
							label="Población"
							v-model="pobclinica"/>
					</v-col>
          <v-col cols="12" v-if="id < 7">
						<v-text-field
							class="pt-0"
							label="Provincia"
							v-model="provclinica"/>
					</v-col>
          <v-col cols="4" v-if="id < 7">
						<v-text-field
							class="pt-0"
							label="Código postal"
							v-model="cpclinica"/>
					</v-col>
          <v-col cols="8" v-if="id < 7">
						<v-text-field
							class="pt-0"
							label="Teléfono"
							v-model="telclinica"/>
					</v-col>
            <v-col cols="12" v-if="id < 7">
						<v-text-field
							class="pt-0"
							label="E-mail"
							v-model="emailclinica"/>
					</v-col>
          <v-col cols="12" v-if="id < 7">
						<v-text-field
							class="pt-0"
							label="Responsable"
							v-model="respoclinica"/>
					</v-col>
				</v-row>
			</v-form>
        </v-card-text>
        <v-divider></v-divider>	
        <v-card-actions style="background-color: #FFFFFF; border-radius: 0 0 4px 4px; border: thin solid rgba(0, 0, 0, 0.12); border-top: 0; margin-bottom: 30px;">
          <v-btn
            text
            color="red"
            class="justify-start"
            @click="addDeletedClinic()">
             <v-icon left dark class="ml-0 mr-0">mdi-delete</v-icon>
            Borrar
          </v-btn>          
          <v-spacer></v-spacer>
          <v-btn 
			text 
			color="primary" 
			@click="addEditedClinic()">
			Editar
          </v-btn>
        </v-card-actions>
        
    </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BaseModule from "./BaseModule";

export default {
	name: "ClinicDialog",
	mixins: [ BaseModule ],
	components: {},
	data() {
		return {
			isLoading: false,
			dialog: false,
			clinic: null,
			id: null,
			clinica: null,
			tipoviacli: null,
			dirclinica: null,
			numeroclinica: null,
			pisoclinica: null,
			cpclinica: null,
			pobclinica: null,
			provclinica: null,
			emailclinica: null,
			telclinica: null,
			respoclinica: null,
			msgCb: null,
		}
	},
	methods: {
		open: function(data, msgCb) {
			this.clinic = data;

			this.id = data.id;
			this.clinica = data.clinica;
			this.tipoviacli = data.tipoviacli;
			this.dirclinica = data.dirclinica;
			this.numeroclinica = data.numeroclinica;
			this.pisoclinica = data.pisoclinica;
			this.cpclinica = data.cpclinica;
			this.pobclinica = data.pobclinica;
			this.provclinica = data.provclinica;
			this.emailclinica = data.emailclinica;
			this.telclinica = data.telclinica;
			this.respoclinica = data.respoclinica;
			
			this.msgCb = msgCb;

			this.dialog = true;
		},
		isOpen: function() {
			return this.dialog;
		},
		close: function() {
			this.dialog = false;
		},
		addDeletedClinic: function() {			
			this.dialog = false;

			if (this.msgCb) {
				this.msgCb({ clinic: this.clinic, deleted: true });
			}
		},
		addEditedClinic: function() {
			if (!this.$refs.form.validate()) {
				return;
			}
			
			this.dialog = false;

			var editedClinic = {
				clinic: {
					id: this.id,
					clinica: this.clinica,
					tipoviacli: this.tipoviacli,
					dirclinica: this.dirclinica,
					numeroclinica: this.numeroclinica,
					pisoclinica: this.pisoclinica,
					cpclinica: this.cpclinica,
					pobclinica: this.pobclinica,
					provclinica: this.provclinica,
					emailclinica: this.emailclinica,
					telclinica: this.telclinica,
					respoclinica: this.respoclinica
				},
				deleted: false
			};

			if (this.msgCb) {
				this.msgCb(editedClinic);
			}
		}
	},
}
</script>